// import React, {Component} from 'react';
import PbAjax from '../../../lib/pbajax';
import publicpb from '../../../base/public.pb';
import validatepb from './validate.pb';

let pbajax = new PbAjax();

class PayResult {
    constructor(orderId,  receipt) {
        this.paramCache = {
            orderId : orderId + '',
            receipt
        };
        this.promise = this.getData(this.paramCache);
    }

    retry() {
        this.promise = this.getData(this.paramCache);
    }

    getData(data) {
        let self = this;
        let receipt = data.receipt;
        let { Request, Response } = validatepb.Mall.PayValidate;
        let businessData = new Request(data);
        let defer = $.Deferred();
        let userToken = UP.Global.getUserToken();
    
        pbajax.do({
                service: 'mall',
        		api: '/mall/pay/validate', 
                header: {
                    userToken
                }
            },
            businessData,
            function(res) {

                let dataWrap = publicpb.Result.decode(res);
                let data;
                
                if (dataWrap.code == 1) {
                	data = Response.decode(dataWrap.data.value);
                	defer.resolve(data);
                } else {
                   defer.reject(dataWrap.code);
                }

            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            }
        );

        return defer.promise();
    }
}

export default PayResult;



// WEBPACK FOOTER //
// ./js/component/recharge/payresult/index.js